import { Button, mergeClasses } from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';
import React from 'react';
import { useSecondRunDismissButtonStyles } from './SecondRunDismissButton.styles';
var SecondRunDismissButton = React.forwardRef(function (_a) {
    var id = _a.id, clickAction = _a.clickAction;
    var styles = useSecondRunDismissButtonStyles();
    var dismissButtonStyles = React.useMemo(function () {
        return mergeClasses(styles.position);
    }, [styles.position]);
    var getIcon = React.useCallback(function () {
        return (React.createElement(Button, { icon: React.createElement(Dismiss24Regular, null), appearance: "subtle", size: "small", "aria-label": "dismiss button", style: { border: 'none' } }));
    }, []);
    var dismissButton = React.useMemo(function () {
        return (React.createElement("button", { id: id, onClick: clickAction, className: dismissButtonStyles },
            React.createElement("div", null, getIcon())));
    }, [clickAction, dismissButtonStyles, getIcon, id]);
    return dismissButton;
});
SecondRunDismissButton.displayName = 'SecondRunDismissButton';
export { SecondRunDismissButton };
//# sourceMappingURL=SecondRunDismissButton.js.map